import React from 'react';
import './Menubar.css';

export default function Menubar() {
  return (
    <div className="Menubar">
      Supreme Draft Simulator - Made by <a href="https://tripplyons.com">Tripp Lyons</a>
    </div>
  )
}
